export default function FAQSection() {
  const faqs = [
    {
      question: '耽美漫画网上的漫画都是免费的吗？',
      answer: '是的，耽美漫画网上的所有耽美漫画和BL漫画资源均免费提供在线阅读，您无需支付任何费用即可畅享海量高清漫画。我们致力于为广大耽美爱好者提供零成本的优质阅读体验。',
    },
    {
      question: '耽美漫画网的漫画多久更新一次？',
      answer: '耽美漫画网保持每日更新频率，我们的编辑团队会持续追踪热门免费耽美漫画的最新章节，确保读者能够第一时间阅读到最新内容。连载中的漫画通常每周更新1-2话。',
    },
    {
      question: '如何在耽美漫画网上找到我想看的漫画？',
      answer: '您可以通过首页的搜索框直接搜索漫画名称或作者，也可以通过分类导航按校园、古风、奇幻、现代、悬疑等类型浏览。首页的热门推荐和最新更新板块也能帮助您发现精彩的免费BL漫画。',
    },
    {
      question: '耽美漫画网支持手机阅读吗？',
      answer: '当然支持！耽美漫画网采用响应式设计，完美适配手机、平板和电脑等各类设备。无论您使用什么设备，都能获得流畅高清的耽美漫画免费阅读体验。',
    },
    {
      question: '我可以下载耽美漫画网上的漫画吗？',
      answer: '耽美漫画网提供在线免费阅读服务，目前暂不支持下载功能。我们建议您在线收藏喜欢的漫画，随时随地进行阅读。如果您特别喜欢某部作品，也请支持正版。',
    },
  ];

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      <section id="faq" className="py-12 md:py-16 px-4 md:px-6 bg-background-100">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-10">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
              常见问题
            </h2>
            <p className="text-sm text-foreground-500 mt-2">
              关于<strong>耽美漫画网</strong>的常见疑问解答
            </p>
          </div>

          <div className="space-y-3">
            {faqs.map((faq, index) => (
              <details key={index} className="group bg-background-50 rounded-lg border border-background-200/70 overflow-hidden">
                <summary className="flex items-center justify-between px-5 py-4 cursor-pointer hover:bg-background-100 transition-colors">
                  <span className="text-sm font-medium text-foreground-800 pr-4">{faq.question}</span>
                  <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 text-foreground-400 group-open:rotate-180 transition-transform duration-200">
                    <i className="ri-arrow-down-s-line"></i>
                  </span>
                </summary>
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.answer}</p>
                </div>
              </details>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}